import { render, staticRenderFns } from "./doctorsList.vue?vue&type=template&id=2234c108&scoped=true"
import script from "./doctorsList.vue?vue&type=script&lang=js"
export * from "./doctorsList.vue?vue&type=script&lang=js"
import style0 from "./doctorsList.vue?vue&type=style&index=0&id=2234c108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234c108",
  null
  
)

export default component.exports